import React, { Component } from 'react';
import CreateAdditionalMaterialInfoSection from './sections/createGeneralInfoSection';

class AdditionalMaterialDisplayView extends Component{
  constructor(props){
    super(props);
    this.state={
      additionalMaterialContent: this.props.additionalMaterialContent,
      language: this.props.language,
      infoValidate: false,
      isCreation: typeof this.props.isCreation !== 'undefined' && this.props.isCreation != null ? this.props.isCreation : false,
    };
    this.onChange = this.onChange.bind(this);
  }

  onChange(field, value){
    //Trick to add to state from multiple inputs with same function
    this.props.onChange(field, value);
  }

  render(){
    return(
      <div style={{padding: "10px"}}>
        <CreateAdditionalMaterialInfoSection
            parentStateHandle={this.props.onChange}
            state={this.props.additionalMaterialContent}
            language={this.props.language}
        />
      </div>
    );
  }
}

export default AdditionalMaterialDisplayView;